import { render, staticRenderFns } from "./TwoColumn-SidebarNarrow.vue?vue&type=template&id=460ad396&scoped=true"
import script from "./TwoColumn-SidebarNarrow.vue?vue&type=script&lang=js"
export * from "./TwoColumn-SidebarNarrow.vue?vue&type=script&lang=js"
import style0 from "./TwoColumn-SidebarNarrow.vue?vue&type=style&index=0&id=460ad396&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "460ad396",
  null
  
)

export default component.exports